import { createContext, useCallback, useMemo, useState, useContext } from "react";
import { Box, ThemeProvider } from "@mui/material";
import { DarkTheme, LightTheme } from "../themes";
import CookieService from "../services/autenticacao/CookieService";

interface IThemeContextData {
    themeName: "light" | "dark";
    toggleTheme: () => void;
}

type Props = {
    children?: React.ReactNode,
};

const ThemeContext = createContext<IThemeContextData>({} as IThemeContextData);

export const useAppThemeContext = () => {
    return useContext(ThemeContext);
}

export const AppThemeProvider: React.FC<Props> = ({ children  }) => {
    const cookieTema = CookieService.get("access_thema");       
    const tema = (cookieTema === undefined || cookieTema === "2") ? "dark" : "light";        
    const [themeName, setThemeName] = useState<"light" | "dark">(tema);

    const toggleTheme = useCallback(() => {       
        setThemeName(oldTheme => oldTheme === "light" ? "dark" : "light");                
        window.location.reload();
    }, []);

    const theme = useMemo(() => {       
        if (themeName === "light"){
            return LightTheme;
        } 
        return DarkTheme;

    }, [themeName])

    return (

        <ThemeContext.Provider value={{ themeName, toggleTheme }}>
            <ThemeProvider theme={theme}>
                <Box height="auto" sx={{minHeight: "100vh"}} bgcolor={theme.palette.background.default}>
                    {children}
                </Box>
            </ThemeProvider>
        </ThemeContext.Provider>
    );
}